import CrudActionSetBase from './CrudActionSetBase'

export class BCTIActionSet extends CrudActionSetBase('bcti'){}
export default new BCTIActionSet()